require('../../../node_modules/photoswipe/dist/photoswipe.css')
require('script-loader!photoswipe')
require('script-loader!../../../node_modules/photoswipe/dist/photoswipe-ui-default.js')

// app files
require('../../../src/config.js')
require('../components/breadcrumbs/breadcrumbs.js')
require('../components/breadcrumbs/breadcrumbs.css')
require('../components/gallery/gallery.js')
require('../components/hierarchytree/hierarchytree.js');
require('../components/hierarchytree/hierarchytree.css');
require('../components/expand/expand.js')
require('../components/expand/expand.css')
require('../../css/uflex.css')
const {createLoadingColumn, createSimpleColumn} = require('../components/finder/findertreeUtils.js')

require('../components/loader/loader.js')
require('./search.service.js')

const mappaturaLabel = require('../maplabel.json')
const mappaturaEnti = require('../ref-ente.json')

require('../../css/dettaglio.css')

angular.module('app')
    .filter('sanitize', ['$sce', function ($sce) {
      return (htmlCode) => {
        if (typeof htmlCode !== 'string' && typeof htmlCode !== 'undefined') {
          htmlCode = '' + htmlCode
        }
        return $sce.trustAsHtml(htmlCode)
      }
    }])
    .filter('filterCol', function () {
      return function (filtro) {
        return encodeURI('types=' + filtro.name + '|' + filtro.id + '|' + filtro.path.replace(new RegExp('/', 'g'), '%2F'))
      }
    })
    .controller('DetailCtrl', function ($http, $timeout, $scope, $window, SearchService, ID, ATTS, ENDPOINT_AGGREGATE, ENDPOINT_ITEM, ENDPOINT_SEARCH, ENDPOINT_SUMMARY, ENDPOINT_SEARCH_URL, BASE_URL, LINKS) {
      const vm = this
      this._ = _
      let parentIndex = -1
      let xhrCnt = 0
      let skipCount = 0
      let limitCount = 16

        // Elementi del controller
      vm.loaded = false
      vm.unavailable = false
      vm.id = ID
      vm.detail = {}
      vm.summary = {}
      vm.fields = ['type_id.name', 'date.date_display.value']
      vm.hasMedia = false
      vm.image = {}
      vm.limitTo = _.fill(Array(3), (limitCount - 1))
      vm.openTree = false
      vm.LINKS = LINKS
      vm.root = {
        name: '',
        id: '',
        path: ''
      }
      vm.parentPath = []
      vm.search = $window.sessionStorage.getItem('search')

      const search = JSON.parse(vm.search)
      this.currentPage = null
      if (search) {
        this.currentPage = search.currentPage
        this.filtriSelezionati = SearchService.getFiltriSelezionati(search)
        this.allKeywords = SearchService.getKeywords(search)

        let sparam = new URLSearchParams()
        for (let p in search) {
          if (_.isArray(search[p])) {
            sparam.set(p, search[p].join('^'))
          } else {
            sparam.set(p, search[p])
          }
        }

        vm.search = new URL(ENDPOINT_SEARCH_URL + '/?' + sparam.toString()).toString()
      }

      vm.runPhotoSwipe = function () {
        var pswpElement = document.querySelectorAll('.pswp')[0]
        if (!pswpElement) { return }
            // define options (if needed)
        let options = {
          shareEl: true,
          clickToCloseNonZoomable: false,
          allowPanToNext: true,
          tapToClose: false,
          pinchToClose: false,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          showHideOpacity: false,
          showAnimationDuration: 0,
          hideAnimationDuration: 0
        }
        const items = vm.representations.map(item => {
          if (item.title) {
            var mimetype = item.title.substr(-3)
          } else if (item.desc) {
            var mimetype = item.desc.substr(-3)
          }
          return {
            src: item.url.thumb,
            title: (item.title != '[VUOTO]') ? item.title : 'immagine senza titolo',
            w: 100,
            h: 100,
            mimetype: mimetype,
            original: item.url.high
          }
        })
        let gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
        gallery.initialImageIndex = options.index // storing initial (clicked) image index

        gallery.listen('gettingData', function (index, item) {
          if (typeof item.html === 'undefined' && typeof item.loaded === 'undefined') {
            item.loaded = true // unknown size
            let url = ''
            let img = new Image()
            img.onload = function () {
              item.src = item.original
              item.w = this.width
              item.h = this.height
              gallery.invalidateCurrItems()
              gallery.updateSize(true)
            }
            img.src = item.original
            img.style.opacity = 1 // show image
          }
        })
        gallery.listen('preventDragEvent', function (e, isDown, preventObj) {
          preventObj.prevent = false
        })

            // DA SISTEMARE
        $timeout(function () {
          gallery.init()
        }, 0)
      }
      init()

      vm.getTableUrl = function (data) {
        return LINKS[data]
      }

      function _loadItem (id) {
        $http.post(ENDPOINT_SUMMARY + '/data/' + ATTS.table + '/' + id)
                .then(function (result) {

                  vm.detail = {
                    'preferred_label': 'Scheda non disponibile'
                  }

                  if (!_.isEmpty(result.data.data.result[0])) {
                    angular.copy(result.data.data.result[0], vm.detail)
                    // if (!_.isEmpty(result.data.data[0])) {
                    //     angular.copy(result.data.data[0], vm.detail);

                    if (!_.isEmpty(vm.detail.summary[0])) {
                      vm.summary = vm.detail.summary[0]
                            // delete vm.detail.summary;
                    }

                    document.title = vm.detail.preferred_label

                    if (vm.detail.access == 0) {
                      vm.detail = {
                        'preferred_label': 'Scheda non disponibile'
                      }
                      vm.loaded = true
                      return
                    }

                    vm.recuperaRelated()

                    if (!_.isEmpty(vm.detail.root)) {
                      vm.root = vm.detail.filtri.filter(fil => {
                        return fil.path.startsWith('/Root/')
                      })[0]
                    }

                    if (!_.isEmpty(vm.detail.filtri)) {
                      vm.filtri = vm.detail.filtri
                                .filter(e => {
                                  return e.path.match(
                                    new RegExp('/((?!Root|tabella|media|tipologiaca_objects|tipologiaca_entities|protagonisti|fondoApparteneza).)+/[A-Za-z0-9/]+', 'g')
                                  )
                                })

                      vm.ente = _.find(vm.detail.filtri, function (e) {
                        return e.path.startsWith('/enteconse/')
                      })

                      if (!_.isEmpty(vm.ente)) {
                        vm.enteLink = !_.isEmpty(mappaturaEnti[vm.ente.name]) ? mappaturaEnti[vm.ente.name] : false
                      }
                    }

                    if (!_.isEmpty(vm.detail.representations)) {

                      vm.representations = []
                      vm.pdf = []
                      vm.audio = []
                      let primary = {}
                      for (let img of vm.detail.representations) {
                        if (img.url.original && img.url.original.endsWith('pdf')) {
                          vm.pdf.push(img)
                        } else if (img.url.original && img.url.original.endsWith('mp3')) {
                          vm.audio.push(img)
                        } else {
                          vm.representations.push(img)
                          if (_.isEmpty(primary)) {
                            primary = img
                          }
                        }
                      }

                      vm.hasMedia = vm.representations.length > 0

                      vm.image = ''
                      if (!_.isEmpty(primary) && !_.isEmpty(primary.url) && !_.isEmpty(primary.url.thumb)) {
                        vm.image = primary.url.thumb
                      }
                    }
                    if (!_.isEmpty(vm.detail.related)) {
                      vm.detail.related = _manageRelatedTable(vm.detail.related)
                            // delete result.data.data.result[0].related;
                      if (angular.equals({}, vm.detail.related)) {
                        vm.detail.related = false
                      }
                    } else {
                      vm.detail.related = false
                    }

                    if (!_.isEmpty(vm.detail.metadati.relations)) {
                      vm.detail.biblio = vm.detail.metadati.relations
                    }

                    vm.detail.metadati = _manageMetadata(vm.detail.metadati)
                    vm.loaded = true
                  }


                }, function errorCallback (response) {
                  console.log(response)
                })
      }


      vm.recuperaRelated = function (index = 0, table = false) {
        let match = {id: ID, table: ATTS.table}
        if (table !== false) {
          match['related.table'] = table
        }
        match['related.access'] = 1
        $http.post(ENDPOINT_AGGREGATE, {
          'table': 'data',
          'query': [
                    {$match: match},
                    {$unwind: '$related'},
                    {$project: {'related': true}},
                    {$match: {'related.access': 1}},
                    {$sort: {'related.name': 1}},
                    {$skip: skipCount},
                    {$limit: limitCount}
          ]
        }).then(function (data) {
          if (data.data.data) {
            skipCount += limitCount
            if (table) { vm.limitTo[index] += limitCount - 1 }
            let result = _manageRelatedTable(data.data.data.result.map(e => e.related))
            if (result) {
              if (vm.detail.related) {
                let tmp = vm.detail.related.slice()
                tmp.push(...result)
                vm.detail.related = angular.copy(tmp, vm.detail.related)
              } else { vm.detail.related = result }
            }
          }
        })
      }

      function _manageMetadata (data) {
        const printContainer = (elem) => {
          let value = ''
          let keys = Object.keys(elem).sort((a, b) => a - b)
          for (let i in keys) {
            if (elem.hasOwnProperty(keys[i]) && elem[keys[i]] !== null) {
              // if (elem[keys[i]].label === "Instestazione d'autorità") {
              //   elem[keys[i]].label = "Intestazione d'autorità"
              // } else if (elem[keys[i]].label === 'Numero di busta') {
              //   elem[keys[i]].label = 'Numero'
              // } else if (elem[keys[i]].label === 'Unità di conservazione - tipo') {
              //   elem[keys[i]].label = 'Unità di conservazione'
              // } else if (elem[keys[i]].label === 'Descrizione del contenuto') {
              //   elem[keys[i]].label = 'Contenuto'
              // }
              if (notUndefined(elem[keys[i]].label) && notUndefined(elem[keys[i]].value)) {
                if (mappaturaLabel[vm.detail.type_id] && mappaturaLabel[vm.detail.type_id][keys[i]]) {
                  elem[keys[i]].label = mappaturaLabel[vm.detail.type_id][keys[i]]
                }
                value += `
                                <div class='row no-m text-left'>
                                    <div class='col-md-4'><span class="upp bolder text-left ls1 fs14">${elem[keys[i]].label}</span>:</div>
                                    <div class='col-md-8'><span class="fs14">${elem[keys[i]].value}</span></div>
                                </div>
                            `
              }
            }
          }
          return value
        }
        const printElem = (elem) => {
          if (_.isString(elem)) {
            elem = "<div class='col-md-12'>" + elem + '</div>'
          } else if (notUndefined(elem.value)) {
            elem = `
                        <div class='row no-m text-left'>
                            <div class='col-md-4'><span class="upp bolder text-left ls1 fs14">${elem.label}</span>:</div>
                            <div class='col-md-8'><span class="fs14">${elem.value}</span></div>
                        </div>
                    `
          } else if (notUndefined(elem.subelement)) {
            elem = printContainer(elem.subelement)
          }
          return elem
        }
            // Metadati
        let metadati = []
        for (const key in data) {
          if (!data.hasOwnProperty(key)) {
            continue
          }

          // let metaSummary = (!_.isEmpty(vm.summary[key])) ?
          //           vm.summary[key] :
          //           (key === 'alternative_names') ?
          //           vm.summary.nonpreferred_labels : {}
          // if (!notUndefined(metaSummary) || !notUndefined(metaSummary.visibile) || metaSummary.visibile <= 0) {
          //   continue
          // }
          let metadato = data[key]
          let value = metadato
                    .filter(elem => elem)
                    .map(elem => {
                      if (!_.isArray(elem)) {
                        // if (mappaturaLabel[vm.detail.type_id] && mappaturaLabel[vm.detail.type_id][key]) {
                        //   elem.label = mappaturaLabel[vm.detail.type_id][key]
                        // } else {
                        //   elem.label = metaSummary.label
                        // }

                        // if (elem.label === "Instestazione d'autorità") {
                        //   elem.label = "Intestazione d'autorità"
                        // } else if (elem.label === 'Numero di busta') {
                        //   elem.label = 'Numero'
                        // }

                        elem = [elem]
                      }
                      let res = _metadataException(elem, key)
                      if (res === false) {
                        return elem.map(printElem).join('')
                      }
                      return res
                    })
                    .join('')
                    .replace(new RegExp('&lt;', 'g'), '<')
                    .replace(new RegExp('&gt;', 'g'), '>')

          if (!_.isEmpty(metadato[0]) && value !== '') {
            var label = (_.isArray(metadato[0])) ? metadato[0][0].label : metadato[0].label
            if (label === 'Instestazione d\'autorità') {
              label = "Intestazione d'autorità"
            }
            metadati.push({
              'label': label,
              value
              // 'ordine': elem.ordine
            })
          }
        }

        // metadati = metadati.sort((a, b) => {
        //   let ordA = parseInt(a.ordine) || 9999
        //   let ordB = parseInt(b.ordine) || 9999

        //   return ordA - ordB
        // })

        return metadati
      }
      function _manageRelatedTable (data) {
        var related = data.filter(fil => fil.access != '0')
        if (_.isEmpty(related)) {
          return false
        }
        return related
      }
      function init () {
        _loadItem(ID)
      }
        // var windowHeight = jQuery(window).innerHeight();
      this.switchTree = function () {
        let treew = jQuery('#wrapper-albero')
            // let treeh = jQuery('#treeHierarchy');
            // let treeOpen = jQuery('#apri-albero').outerHeight();
        vm.openTree = !vm.openTree
        if (vm.openTree) {
                // treew.css('height', (windowHeight - treeOpen - 80));
          treew.addClass('treeOpened')
          if (vm.openTree) {
            $timeout(function () {
              angular.element('#finderContainer').scrollLeft(800)
            }, 5)
          }
          if (vm.representations) {
            jQuery('.photoswipe.fix-h-650').css({
              'height': '0',
              'padding-top': '0'
            })
          }
        } else {
                // treew.css({'height': 200, 'overflow': 'auto'});
          treew.removeClass('treeOpened')
          if (vm.representations) {
            jQuery('.photoswipe.fix-h-650').css({
              'height': '650',
              'padding-top': '45px'
            })
          }
        }
      }
      function notUndefined (param) {
        return typeof param !== 'undefined'
      }
      if (vm.allKeywords || vm.filtriSelezionati || vm.currentPage) {
        SearchService.recuperaDati(vm.allKeywords, vm.filtriSelezionati, vm.currentPage, 5, {'score': { '$meta': 'textScore'}}).then(function (result) {
          vm.relatedSearch = result.data.data
                    .filter(e => e.id !== vm.detail.id)
                    .slice(0, 4)
        })
      }
         // Metodi per la gestione del finder
      vm.remoteSource = function (parent, cfg, callback) {

        if (parent && !parent.isChild && !parent.children) {
          const loadingIndicator = createLoadingColumn()
          var xhrUid = ++xhrCnt
                // loading spinner
          if (!parent || !parent.isChild) {
            cfg.emitter.emit('create-column', loadingIndicator)
          }

          let query = {'parent_path': (parent ? {'$regex': `/\/${parent.id}$/`} : '1'), 'access': {'$in': [1]}}

          $http.post(ENDPOINT_SEARCH, {
            'table': 'hierarchy',            
            'sort': {'ordine': 1},
            'query': query
          })
                .then(data => {
                  if (xhrUid !== xhrCnt) { return }

                  angular.element(loadingIndicator).remove()
                  let isMobile = false
                  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) { isMobile = true }
                  if (isMobile) {
                    data.data.data = data.data.data.map(d => {
                      d.mobile_url = BASE_URL + LINKS[d.table] + '/' + d.id + '_' + _.kebabCase(d.name)
                      if (d.children) {
                        d.children = d.children.map(ed => {
                          ed.mobile_url = BASE_URL + LINKS[ed.table] + '/' + ed.id + '_' + _.kebabCase(ed.name)
                          return ed
                        })
                      }
                      return d
                    })
                  } else {
                    data.data.data = data.data.data.map(d => {
                      d.url = BASE_URL + LINKS[d.table] + '/' + d.id + '_' + _.kebabCase(d.name)
                      if (d.children) {
                        d.children = d.children.map(ed => {
                          ed.url = BASE_URL + LINKS[ed.table] + '/' + ed.id + '_' + _.kebabCase(ed.name)
                          return ed
                        })
                      }
                      return d
                    })
                  }
                  data.data.data = data.data.data.map(d => {
                    if (d.children) {
                      d.children = d.children.sort((a, b) => {
                        return a.ordine - b.ordine
                      })
                    }
                    return d
                  }).sort((a, b) => {
                    return a.ordine - b.ordine
                  })
                  callback(data.data.data)
                })
          return
        } else if (!vm.loaded || vm.openTree) { jQuery('#wrapper-albero'); return }

        let idToSearch = vm.detail.root ? vm.detail.root.id : vm.detail.id
        if (!idToSearch) { jQuery('#wrapper-albero').hide(); return }
        $http.post(ENDPOINT_SEARCH, {
          table: 'hierarchy',
          query: {'$or': [{ 'parent_path': {'$regex': `/^1\/${idToSearch}/`}, 'access': 1 }, {'id': idToSearch}]},
          'sort': {'ordine': 1}
          // query: { 'parent_path': {'$regex': `/^1\/${idToSearch}/`}, 'access': 1 }
          // query: {'id': idToSearch}
        }).then(function (result) {

          const currentElem = _.find(result.data.data, function (elem) { return elem.id === vm.detail.id })

          if (!currentElem) { return }
          const pPath = currentElem.parent_path.split('/')

          const listItems = result.data.data
          .filter(elem => pPath.indexOf(elem.id) > 0 && elem.access !== 0)
          .sort((a, b) => b.parent_path.length - a.parent_path.length)
          .map(d => {
            if (d.children) {
              d.children = d.children.sort((a, b) => {
                return a.ordine - b.ordine
              })
            }
            return d
          })
          
          let data = listItems.reduce((prev, current, index) => {
            // if (_.isEmpty(prev)) {
            //   prev = current
            //   prev.url = BASE_URL + LINKS[prev.table] + '/' + prev.id + '_' + _.kebabCase(prev.name)
            //   return prev
            // }
            if (current.children) {
              current.children = current.children.filter(Boolean).map(e => {
                if (e.access !== 0) {
                  if (e.id === prev.id && prev.children && prev.children.length > 0) {
                    e.children = prev.children.filter(Boolean).map(ed => {
                      ed.url = BASE_URL + LINKS[ed.table] + '/' + ed.id + '_' + _.kebabCase(ed.name)
                      return ed
                    })
                  }
                  e.url = BASE_URL + LINKS[e.table] + '/' + e.id + '_' + _.kebabCase(e.name)
                  return e
                }
              })
            }
            current.url = BASE_URL + LINKS[current.table] + '/' + current.id + '_' + _.kebabCase(current.name)
            return current
          }, {})

          vm.parentPath = listItems.sort((a, b) => a.parent_path.length - b.parent_path.length)          
          vm.parentPath.push(currentElem)
          if (_.isEmpty(data)) {
            if (currentElem.children) {
              currentElem.children = currentElem.children.filter(e => e.access === 1).map(ed => {
                ed.url = BASE_URL + LINKS[ed.table] + '/' + ed.id + '_' + _.kebabCase(ed.name)
                return ed
              })
            }
            data = currentElem
          }
          data = [data].map(d => {
            if (d.children) {
              d.children = d.children.sort((a, b) => {
                return a.ordine - b.ordine
              })
            }
            return d
          })
          callback(data)

        })
      }

      vm.columnCreated = function (d, ghg) {
        const $elem = angular.element(d)

        if ($elem.find('li').length <= 0 && $elem.find('.apice-load').length <= 0) {
          $elem.remove()
        } else {
          parentIndex++
          if (parentIndex < vm.parentPath.length - 1) {
            ghg.emit('create-column', createSimpleColumn(ghg, vm.parentPath[parentIndex], vm.parentPath[parentIndex + 1], BASE_URL + LINKS[vm.parentPath[parentIndex].table]))
          }
        }
      }

      vm.itemSelected = function (d, ghg) {
        console.log(d)
      }
      function _metadataException (metadata = [], key) {
        switch (key) {
          case 'external_link':
            if (!_.isEmpty(metadata[0].url) && !_.isEmpty(metadata[0].nome_sito)) {
              return "<a class='link-inner' href='" + metadata[0].url.value + "' target='_blank'>" + metadata[0].nome_sito.value + '</a>'
            } else {
              return false
            }
          case 'date':
            if (!_.isEmpty(metadata[0].subelement) && !_.isEmpty(metadata[0].subelement.data_value)) {
              let string = `<div class="row no-m"><div class='col-md-4'><span class="upp bolder ls1 fs14">${metadata[0].label}</span>:</div>
                            <div class='col-md-8 fs14'>${metadata[0].subelement.data_value.value}</div></div>`
              if (!_.isEmpty(metadata[0].subelement.note_data)) {
                string += `<div class="row no-m"><div class='col-md-4'><span class="upp bolder ls1 fs14">Note alla data</span>:</div>
                            <div class='col-md-8 fs14'>${metadata[0].subelement.note_data.value}</div></div>`
              }
              return string
            } else {
              return false
            }
          case 'url_pdf':
            vm.dowPDF = metadata[0].value
            return ''
          case 'descrittore':
            return ''
          case 'biography':
          case 'description':
            vm.descriptionsElem = metadata
            return ''
          case 'luogo':
            let label = ''
            let value = ''
            if (metadata[0].subelement && metadata[0].subelement.nome_luogo) {
              label = 'Luogo'
              if (metadata[0].subelement && metadata[0].subelement.tipologia) {
                label = metadata[0].subelement.tipologia.value
              }
              value = metadata[0].subelement.nome_luogo.value
              if (!_.isEmpty(vm.detail.metadati.deduzione)) {
                value = '[' + value + ']'
                delete vm.detail.metadati['deduzione']
              }
            } else {
              value = metadata[0].value
              label = metadata[0].label
              if (!_.isEmpty(vm.detail.metadati.deduzione)) {
                value = '[' + value + ']'
                delete vm.detail.metadati['deduzione']
              }
            }

            if (!label || label === '' || !value || value === '') {
              return ''
            }

            return `<div class="row no-m"><div class='col-md-4'><span class="upp bolder ls1 fs14">${label}</span>:</div>
                        <div class='col-md-8 fs14'>${value}</div></div>`
          case 'conservazione':
            if (!_.isEmpty(metadata[0].subelement.busta_numero)) {
              return `<div class='col-md-4'><span class="upp bolder ls1 fs14">${metadata[0].label}</span>:</div>
                        <div class='col-md-8 fs14'>${metadata[0].subelement.busta_numero.value}</div>`
            }
            return false
          default:
            let valore = _.find(vm.detail.filtri, function (fil) {
              let trovato = false
              for (let k in metadata[0]) {
                if (trovato) {
                  break
                }
                trovato = ((k === 'value') ?
                               metadata[0][k] :
                                (!_.isEmpty(metadata[0][k]) && !_.isEmpty(metadata[0][k].value) ? metadata[0][k].value : false)
                          ) === fil.name
              }
              return trovato
            })

            if (!valore)
              return false

            let filtroLink = ENDPOINT_SEARCH_URL + '/?currentPage=0&types=' + valore.name + '|' + valore.id + '|' + valore.path
            return `
              <div class='row no-m'>
                  <div class='col-md-4'><span class="upp bolder ls1 fs14">${metadata[0].label}</span>:</div>
                  <div class='col-md-8'>
                      <a href="${filtroLink}" class="tag-filter bg-theme">
                          ${metadata[0].value}
                      </a>
                  </div>
              </div>
            `
        }
      }
    })



// WEBPACK FOOTER //
// ./src/js/pages/dettaglio.js